
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
import { modelUtils } from '@/utils'
let { WizContainer } = framework_tool
let { WizForm, WizInput, WizRow, WizCol, WizButton, WizSelect } = component_tool

class Verify extends WizContainer {
    componentName = 'Verify'

    constructor(props) {
        super(props)
        let { record, rows } = props
        if (record) {
            record.status = 0
        }
        this.state = {
            batch: rows ? true : false,
            record,
            rows,
            remark: '',
            status: 0,
            timestamp: new Date().getTime()
        }
    }


    _recordColumns = (record = {}) => {
        return [
            {
                title: '场地名称',
                name: 'name',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return <div>{record.name || ''}</div>
                    }
                }
            },
            {
                title: '场地编号',
                name: 'code',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return <div>{record.code || ''}</div>
                    }
                }
            },
            {
                title: '使用时间',
                name: 'useDate',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return <div>{record.useDate || ''}</div>
                    }
                }
            },
            {
                title: '核实确认',
                name: 'status',
                dict: [
                    { code: 0, codeName: '准确' },
                    { code: 1, codeName: '不准确' }
                ],
                formItem: {
                    type: 'radio',
                    onChange: (form, value, e) => this.setState({ status: value })
                }
            },
            {
                title: '核实备注',
                name: 'remark',
                formItem: {
                    type: 'textarea',
                    // render: () => {
                    //     return (
                    //         <>
                    //             <WizInput.TextArea
                    //                 placeholder='请输入核实备注'
                    //                 maxLength={100}
                    //                 autoSize={{ minRows: 3, maxRows: 3 }}
                    //                 onChange={(e) => this.setState({ remark: e.target.value })}
                    //             />
                    //             <div>{this.state.remark.length + '/100'}</div>
                    //         </>
                    //     )
                    // }
                    onChange: (form,text) => {
                        this.setState({ remark: text })
                    }
                }
            }
        ]
    }

    propsAndStateOnChange = {
        verify: this._verify.bind(this),
        rows: this._changeState.bind(this),
        record: this._changeState.bind(this),
    }

    _changeState(nextProps, nextState) {
        let { record, rows } = nextProps
        if (record) {
            record.status = 0
        }
        nextState = {
            batch: rows ? true : false,
            record,
            rows,
            remark: '',
            status: 0,
            timestamp: new Date().getTime()
        }
        return true;
    }

    _verify(nextProps, nextState) {
        let { verify } = nextProps;
        if (verify['success']) {
            wizNotice.success('操作成功')
            let { changeModal } = this.props
            if (changeModal) {
                changeModal(false, true, true)
            }
        } else {
            wizNotice.error(verify.msg || '操作失败,请稍后尝试')
        }
    }

    _onSave = () => {
        let { changeModal } = this.props
        let { batch, record, rows, status, remark } = this.state
        let ids = []
        if (batch) {
            rows && rows.length && rows.forEach(row => {
                ids.push(row.id)
            })
        } else {
            ids.push(record.id)
        }
        if (ids.length) {
            this.doAction({
                path: 'siteOrderCheck/verify',
                payload: {
                    key: 'verify',
                    apiParams: {
                        ids,
                        status,
                        remark
                    }
                }
            })
        } else {
            if (changeModal) {
                changeModal(false, true)
            }
        }
    }

    _onReset = () => {
        this.refs.formRef && this.refs.formRef.resetFields && this.refs.formRef.resetFields()
        this.setState({ rows: this.props.rows, remark: '', status: 0 }) 
    }

    _renderFooter = () => {
        return (
            <React.Fragment>
                <div style={{ paddingLeft: 15, display: 'inline-block' }}>{this.state.remark.length + '/100'}</div>
                <WizRow className="form-btns row-item">
                    <WizCol span={24}>
                        <WizButton title='保存' type='primary' onClick={() => this._onSave()}>保存</WizButton>
                        <WizButton title='重置' type='reset' onClick={() => this._onReset()}>重置</WizButton>
                    </WizCol>
                </WizRow>
            </React.Fragment>
        )
    }

    _render() {
        let { batch, record, timestamp } = this.state
        if (batch) {
            return this._renderForm()
        } else {
            let columns = this._recordColumns(record)
            let formProps = {
                ref: 'formRef',
                key: timestamp,
                columns,
                record: record || { status: 0 },
                preview: false,
                footer: this._renderFooter(),
                formItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 17 }
                }
            }
            return <WizForm {...formProps} />
        }
    }

    _renderForm = () => {
        let value = []
        this.props.rows.forEach(row => {
            value.push(row.id)
        })
        let columns = this._rowsColumns()
        let formProps = {
            ref: 'formRef',
            columns,
            record: null,
            preview: false,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        return (
            <>
                <strong>{'当前已选中： '} <strong>{this.state.rows.length}</strong> {' 条预约申请'}</strong>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <WizSelect
                        style={{ width: 450 }}
                        mode='multiple'
                        open={false}
                        defaultValue={value}
                        onChange={(value, option) => this._wizSelectOnChange(value, option)}
                    >
                        {this.props.rows.map((row, i) => {
                            let title = '场地名称：' + row.name + '     使用时间：' + row.useDate
                            return (
                                <WizSelect.Option key={row.id} value={row.id} title={title}>
                                    {title}
                                </WizSelect.Option>
                            )
                        })}
                    </WizSelect>
                </div>
                <WizForm {...formProps} />
            </>
        )
    }

    _wizSelectOnChange = (value, option) => {
        let { rows } = this.state
        let nextRows = []
        rows.length && rows.forEach(row => {
            value.some(item => { return row.id === item }) && nextRows.push(row)
        })
        this.setState({ rows: nextRows, timestamp: new Date().getTime() })
    }

    _rowsColumns = () => {
        return [
            {
                title: '核实确认',
                name: 'status',
                dict: [
                    { code: 0, codeName: '准确' },
                    { code: 1, codeName: '不准确' }
                ],
                formItem: {
                    type: 'radio',
                    initialValue: 0,
                    onChange: (form, value, e) => this.setState({ status: value })
                }
            },
            {
                title: '核实备注',
                name: 'remark',
                formItem: {
                    type: 'textarea',
                    // render: () => {
                    //     return (
                    //         <>
                    //             <WizInput.TextArea
                    //                 placeholder='请输入核实备注'
                    //                 maxLength={100}
                    //                 autoSize={{ minRows: 3, maxRows: 3 }}
                    //                 onChange={(e) => this.setState({ remark: e.target.value })}
                    //             />
                    //             <div>{this.state.remark.length + '/100'}</div>
                    //         </>
                    //     )
                    // }
                    onChange: (form,text) => {
                        this.setState({ remark: text })
                    }
                }
            }
        ]
    }
}

const mapStateToProps = (state, ownProps) => {
    const { siteOrderCheck } = state
    const load = modelUtils.getLoadingState(state, 'siteOrderCheck')
    const verify = modelUtils.getModelEntity(siteOrderCheck, 'verify')
    return {
        verify,
        ...load
    }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Verify)
